// Helper function to extract error messages from various error formats
export const getErrorMessage = (error) => {
  // Check for axios error response
  if (error.response) {
    // Server responded with error status
    if (error.response.data) {
      // FastAPI returns detail
      if (error.response.data.detail) {
        if (typeof error.response.data.detail === 'string') {
          return error.response.data.detail;
        }
        // Handle array of errors (validation errors)
        if (Array.isArray(error.response.data.detail)) {
          return error.response.data.detail
            .map(err => err.msg || JSON.stringify(err))
            .join(', ');
        }
        return JSON.stringify(error.response.data.detail);
      }
      // Other error formats
      if (error.response.data.message) {
        return error.response.data.message;
      }
      if (error.response.data.error) {
        return error.response.data.error;
      }
      // Return stringified data if nothing else
      if (typeof error.response.data === 'string') {
        return error.response.data;
      }
    }
    // Return status text as fallback
    return `Error ${error.response.status}: ${error.response.statusText}`;
  }
  
  // Check for request error (no response)
  if (error.request) {
    return 'No response from server. Please check your connection.';
  }
  
  // Check for error message
  if (error.message) {
    return error.message;
  }
  
  // Fallback
  return 'An unexpected error occurred. Please try again.';
};
